export { default } from './Collapsible'
